// extracted by mini-css-extract-plugin
export var photo = "photo-module--photo--3WcjJ";
export var imageContainer = "photo-module--imageContainer--1hpsf";
export var ratioKeeper = "photo-module--ratioKeeper--1MSOB";